<template>
    <div class="container text-center text-lg-left p-0">
        <header>
            <a :href="$t('order.check_services.plagiarism.link_address')"
               class="text-decoration-none"
            >
                <h1 class="m-0">
                    <IconGraduationCap :color="'#FC5216'" />
                    <span class="header-title" v-text="'Plagiarism checker'" />
                </h1>
            </a>
        </header>
    </div>
</template>
<script>
import IconGraduationCap from '../IconGraduationCap';

export default {
    components: { IconGraduationCap },
};
</script>
<style scoped lang="scss">
@import '~assets/css/_base.scss';

.header-title {
  font-size: 1.25rem;
  vertical-align: middle;
  user-select: none;

  a {
  }

  svg {
    height: 0.85rem;
  }

  @include media-breakpoint-up(lg) {
    font-size: 1.5rem;
    svg {
      height: 1rem;
    }
  }
}
</style>
